'use client'

import { highlightText } from '@/modules/hs/utils/highlight'

interface HighlightedTextProps {
  text: string
  searchTerm?: string
  className?: string
}

export default function HighlightedText({
  text,
  searchTerm,
  className = '',
}: HighlightedTextProps) {
  if (!searchTerm) {
    return <span className={className}>{text}</span>
  }

  const parts = highlightText(text, searchTerm)

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.highlighted ? (
          <mark
            key={index}
            className="bg-yellow-200 text-inherit rounded-sm px-0.5"
          >
            {part.text}
          </mark>
        ) : (
          <span key={index}>{part.text}</span>
        )
      )}
    </span>
  )
}
